<template>
  <div class="main">
    <div class="contentInfo">
      <div class="bgc">
        <div class="contact">
          <div class="welcome">Welcome to Holden eQuote platform. Through this portal you will be able to instantly retrieve the feasibility and cost of running a healthcare project in the Asian markets.</div>
          <div class="form">
            <el-form @submit.native.prevent :model="ruleForm" :rules="rules" ref="ruleForm" label-width="auto">
              <el-form-item label="Email" prop="username">
                <el-input v-model="ruleForm.username" @keyup.enter.native="submitForm('ruleForm')" placeholder="Please fill in your registered email address" />
              </el-form-item>
              <el-form-item label="Password" prop="password">
                <el-input show-password v-model="ruleForm.password" @keyup.enter.native="submitForm('ruleForm')" placeholder="Please fill in your password" />
              </el-form-item>
            </el-form>
            <div class="flexCenter">
              <div class="button" @click="submitForm('ruleForm')" v-if="!loadingLogin">
                Login
              </div>
              <div class="button" v-if="loadingLogin">
                <i class="el-icon-loading"></i>Login
              </div>
            </div>
            <div class="register" style="color:red">* Don't have an account? <span style="color:#217df6; cursor: pointer;" @click="$router.push('/register?source=equote')"> Register</span></div>
            <div class="register" style="color:red">* If you forget your password？ <span style="color:#217df6; cursor: pointer;" @click="$router.push('/forgetPassword?source=equote')">Reset</span></div>
            <div class="tips">This port is for Holden client and APPA member only. Please <span class="contactus" @click="$router.push('/register?source=equote')">contact us</span> if you are interested in more details</div>
          </div>
        </div>
      </div>

    </div>

    <!-- <div class="illustrate">
      <div class="tip">
        <div class="title">
          Quotation At Your Finger-Tips
        </div>
        <div class="tips">
          <div class="tipName">
            √ Instant Quotations:
          </div>
          <div class='tipValue'>
            Get quick, comprehensive quotes with just a few clicks, eliminating waiting times.
          </div>
        </div>
        <div class="tips">
          <div class="tipName">
            √ Wide Coverage:
          </div>
          <div class='tipValue'>
            Coverage of different levels of physicians in Asian markets for comprehensive data support.
          </div>
        </div>
        <div class="tips">
          <div class="tipName">
            √ Accurate and Reliable:
          </div>
          <div class='tipValue'>
            Built on extensive data analysis and precise market intelligence for informed decisions.
          </div>
        </div>
        <div class="tips">
          <div class="tipName">
            √ User-Friendly:
          </div>
          <div class='tipValue'>
            Intuitive interface suitable for all experience levels.
          </div>
        </div>
      </div>
      <div class="how">
        <div class="title">
          How to use eQuote
        </div>
        <div class="howtips">
          <div class="howtipsbox">
            Register
          </div>
          <div class="howtipsbox">
            Set Password
          </div>
          <div class="howtipsbox">
            Login and get quotation
          </div>
          <div class="howtipsbox">
            Get quotation
          </div>
          <div class="howtipsbox">
            Input sample size and confirm info
          </div>
          <div class="howtipsbox">
           Input basicproject info
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
const defaultForm = {
  username: "",
  password: ""
};
import { editConsultMail, advertisementFlow, login } from "@/api/api";
export default {
  name: "Contact",
  data() {
    const check = (rule, value, callback) => {
      if (value == false) {
        return callback(new Error("Please complete this required field"));
      } else {
        callback();
      }
    };
    return {
      index: 0, // 索引
      delay: 500, // 滚动事件间隔时间
      lock: false, // 锁
      loadingLogin: false,
      dialogVisible: false,
      checkList: [],
      interested: "",
      ruleForm: JSON.parse(JSON.stringify(defaultForm)),
      showTip: false,
      tipStatus: true,
      rules: {
        username: [
          { required: true, message: "This field is required.", trigger: "change" },
          { type: "email", message: "The email format is incorrect", trigger: "change" }
        ],
        password: [{ required: true, message: "This field is required.", trigger: "blur" }]
      }
    };
  },
  created() {
    this.advertisementFlow(); // 在组件创建时加载Google代码
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://www.googletagmanager.com/gtag/js?id=AW-11335422054";
    document.head.appendChild(script);
    script.onload = () => {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        dataLayer.push(arguments);
      }
      gtag("js", new Date());
      gtag("config", "AW-11335422054");
    };
    this.iscookies();
    this.webinercookies();
  },
  // mounted() {
  //   this.$el.addEventListener("mousewheel", this.mousewheelHandler);
  // },
  // watch: {
  //   index(newVal, oldVal) {
  //     if (newVal !== oldVal) {
  //       // 防止往相同的位置滚动后就要无辜等待delay秒才能再次滚动
  //       this.lock = true;
  //     }
  //   }
  // },
  methods: {
    mousewheelHandler(event) {
      let value = event.wheelDelta > 0 ? "up" : "down";
      this.scrollHandler(value);
    },
    scrollHandler(value) {
      if (this.lock) {
        console.log(this.lock);
        return;
      }
      let mapIndex = {
        up: Math.max(0, this.index - 1),
        down: Math.min(this.$el.children.length - 1, this.index + 1)
      };
      this.index = mapIndex[value];
      this.$el.children[this.index].scrollIntoView({ behavior: "smooth" });
      setTimeout(() => (this.lock = false), this.delay);
    },
    webinercookies() {
      // 如果没有记录cookie
      if (!localStorage.getItem("webinersource")) {
        // 就不重新赋值
        let webinersource = this.$route.query.source;

        if (webinersource == undefined) {
          localStorage.setItem("webinersource", "www");
        } else {
          localStorage.setItem("webinersource", webinersource);
        }
        // console.log(1);
      } else {
        // 如果没有cookie就设置cookie
      }
    },
    // 检测是否登录过，然后跳转
    iscookies() {
      // 如果登录过,看看过期没有，过期了要删除
      if (localStorage.getItem("logincookies")) {
        var val = localStorage.getItem("logincookies");
        var dataobj = JSON.parse(val);

        var newTime = new Date().getTime();
        if (newTime - dataobj.time > 21600000) {
          localStorage.removeItem("logincookies");
        }
      }
      if (localStorage.getItem("logincookies")) {
        // 把client赋值到链接
        var loginclient = JSON.parse(localStorage.getItem("login"));
        // 跳转
        this.$router.push({ name: "Table", query: { client: loginclient, source: "equote" } });
      }
    },
    // 登录
    advertisementFlow() {
      // 如果没有source
      if (this.$route.query.source == undefined) {
        // console.log(1);
        // 就把source拼接
        advertisementFlow({
          path: "equote",
          source: "",
          information: "登录页"
        }).then(res => {
          if (res.code == 10000) {
            // console.log(res);
          }
        });
        // 如果有source
      } else {
        advertisementFlow({
          path: "equote",
          source: this.$route.query.source,
          information: "登录页"
        }).then(res => {
          if (res.code == 10000) {
            // console.log(res);
          }
        });
      }
    },
    change() {
      this.interested = this.checkList.join();
      console.log(this.interested);
    },
    // keyup() {
    //   this.$refs["ruleForm"].clearValidate();
    // },
    submitForm(formName) {
      let _this = this;
      _this.$refs[formName].validate(valid => {
        if (valid) {
          let ruleForm = {
            // grant_type: "password"
            userName: _this.ruleForm.username,
            userPWD: _this.ruleForm.password
          };
          this.loadingLogin = true;
          login(ruleForm).then(res => {
            console.log(res);
            if (res.code != 20001) {
              _this.showTip = true;
              _this.tipStatus = true;
              _this.ruleForm = JSON.parse(JSON.stringify(defaultForm));
              _this.dialogVisible = true;
              var logontime = new Date().getTime();
              localStorage.setItem("logincookies", JSON.stringify({ val: "logincookies", time: logontime }));
              var client = res.client;
              var quotation = res.quotation;
              var discount = res.discount;
              var clientName = res.clientName;
              var isHolden = res.isHolden;
              localStorage.setItem("login", JSON.stringify(client));
              localStorage.setItem("clientName", JSON.stringify(clientName));
              localStorage.setItem("isHolden", JSON.stringify(isHolden));

              localStorage.setItem("quotation", JSON.stringify(quotation));
              localStorage.setItem("discount", JSON.stringify(discount));

              // var userName = res.userName;
              _this.$router.push({ name: "Table", query: { client: client, source: "equote" } });
              this.loadingLogin = false;
            } else {
              this.$message({
                showClose: true,
                message: "Login failed, the Email or Password you entered is incorrect or does not exist!",
                type: "error",
                offset: 100
                // duration:0
              }).$textel;
              var el = document.querySelector(".el-message");
              var textel = document.querySelector(".el-message__content");
              if (window.innerWidth <= 700) {
                if (el) {
                  el.style.cssText = "z-index:500; min-width:380px;height:50px";
                }
                if (textel) {
                  textel.style.cssText = "font-size:10px;";
                }
              }
              this.loadingLogin = false;
            }
          });
          return false;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.check {
  margin-right: 10px;
}
.marginTop30 {
  margin-top: 0.3rem;
}
.fontBold {
  font-weight: bold;
}
.contentInfo {
  background: url("https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/background.jpg") no-repeat center top;
  background-size: 100% 100%;
  width: 100%;
  padding: 38px 0 35px;
  .contact {
    padding: 85px 550px 85px 20px;
    width: 80%;
    background: url("https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/eQuoteBg.png") no-repeat center top;
    background-size: cover;
    margin: 0 auto;
    // background: #fff;
    // border: 1px solid #000;
    .welcome {
      padding-left: 20px;
      text-align: center;
    }
    .form {
      background-color: #fff;
      padding: 50px 20px;
      /deep/.el-form-item {
        // display: flex;
        .el-form-item__label {
          width: 130px;
        }
        .el-form-item__content {
          .el-form-item__error {
            font-size: 12px !important;
          }
        }
        .el-input {
          width: 400px;
        }
        .el-input__inner {
          width: 400px;
        }
      }

      .button {
        // margin-right: 60px;
        margin-top: 17px;
        background: #217df6;
        font-size: 17px;
        color: #fff;
        border-radius: 7px;
        text-align: center;
        width: 300px;
        height: 40px;
        line-height: 40px;
        cursor: pointer;
      }
      .registerBox {
      }
      .register {
        width: 270px;
        margin: 0 auto;
        margin-top: 10px;

        //text-align: center;
        font-size: 14px;
      }
      .tips {
        margin-top: 30px;
        font-size: 13px;
        .contactus {
          cursor: pointer;
          color: #217df6;
          &:hover {
            text-decoration: underline;
          }
        }
      }
    }
  }
}
.illustrate {
  margin-bottom: 20px;
  .tip {
    padding: 0 100px;
    // width: 1000px;
    margin: 0 auto;
    .title {
      text-align: center;
      font-size: 40px;
      font-weight: 700;
      margin: 20px;
    }
    .tips {
      display: flex;
      font-size: 20px;
      .tipName {
        width: 300px;
        font-weight: 700;
      }
    }
  }
  .how{
    padding: 20px 150px;
    .title{
font-size: 40px;
text-align: center;
font-weight: 700;
margin-bottom: 20px;
    }
    .howtips{
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .howtipsbox{
        width: 30%;
        border: 1px solid #000;
text-align: center;
padding: 20px;
font-weight: 700;
font-size: 20px;
border-radius: 10px;
margin-bottom: 20px;
height: 100px;
background-color: #fdfcfc;
display: flex;
justify-content: center;
align-items: center;
      }
    }
  }
}
@media screen and (max-width: 576px) {
  .checkyes {
    font-size: 60px;
  }
  .type {
    font-size: 70px;
  }
  .check {
    width: 100px;
    height: 100px;
  }
  .contentInfo {
    .contact {
      padding: 200px 130px;
      width: 100%;
      .welcome {
        font-size: 50px;
        margin-bottom: 50px;
      }
      .form {
        /deep/.el-form-item {
          // height: 150px;
          margin-bottom: 50px;
          .el-form-item__label {
            font-size: 60px;
            height: 80px;
            line-height: 80px;
            // padding-top: 10px;
            width: auto;
          }
          .el-form-item__label::before {
            top: -10px;
            right: -20px;
          }
          .el-form-item__content {
            .el-form-item__error {
              font-size: 50px !important;
              // left: 0px;
              top: 100px;
              // width: 1000px;
            }
          }
          .el-input {
            width: 750px;
          }
          .el-input__inner {
            height: 90px;
            width: 750px;
            font-size: 50px;
            margin-left: 30px;
            margin-bottom: 50px;
          }
        }
        .button {
          font-size: 60px;
          width: 300px;
          height: 100px;
          line-height: 100px;
        }
        .register {
          font-size: 50px;
          margin-top: 60px;
        }
        .tips {
          font-size: 50px;
          margin-top: 70px;
        }
        .el-input__suffix {
          width: 100px;
          height: 100px;

          .el-input__suffix-inner {
            .el-input__icon {
              font-size: 50px !important;
            }
          }
        }
      }
    }
  }
}
// .main {
//   overflow: hidden;
// }
// .main,
// .main > div {
//   height: 100%;
// }
// .main > div:nth-child(1) {
//   background-color: #f00;
// }
// .main > div:nth-child(2) {
//   background-color: #0f0;
// }
// .main > div:nth-child(3) {
//   background-color: #00f;
// }
</style>

